export default "__VITE_ASSET__DNXtPTot__"